import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51e6f914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = { class: "account-avatar mx-auto mb-4" }
const _hoisted_5 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_6 = { class: "mt-3 text-sm text-gray-600" }
const _hoisted_7 = { class: "mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-2xl text-primary-600 text-center" }
const _hoisted_10 = { class: "mt-6 space-y-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "account-avatar" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "min-w-0 flex-1 text-left" }
const _hoisted_16 = { class: "block truncate font-semibold text-gray-800" }
const _hoisted_17 = { class: "block truncate text-sm text-gray-500" }
const _hoisted_18 = ["title", "aria-label", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "selected-account"
}
const _hoisted_20 = { class: "account-avatar" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "min-w-0 flex-1" }
const _hoisted_24 = { class: "block truncate" }
const _hoisted_25 = { class: "block truncate text-sm text-gray-500" }
const _hoisted_26 = {
  for: "ecp-account-login",
  class: "block text-gray-600"
}
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "text-lg text-gray-600 text-center" }
const _hoisted_29 = {
  key: 1,
  class: "input-form-error-text text-center",
  style: {"font-size":"16px"}
}
const _hoisted_30 = { class: "text-lg text-gray-600 text-center" }
const _hoisted_31 = { class: "text-lg text-gray-600 text-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "text-2xl text-primary-600" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "relative mt-5" }
const _hoisted_36 = ["type", "placeholder"]
const _hoisted_37 = ["aria-label", "title", "aria-pressed"]
const _hoisted_38 = { class: "text-lg text-red-600 text-center" }
const _hoisted_39 = { class: "mt-10" }
const _hoisted_40 = { class: "text-lg text-gray-600 text-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive, onMounted, computed } from "vue";
import { EyeIcon, EyeOffIcon } from "@heroicons/vue/outline";
import { Button } from "@/components/common/";
import { useStore } from "vuex";
import { AuthActions, AuthIdentity } from "@/store/modules/auth";
import router from "@/router";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { LoaderActions, LoaderGetters } from "@/store/modules/loader";
import Loader from "@/components/common/Loader.vue";
import { t } from "@/i18n";
import { createAuthCmsSignatureFromBase64 } from "@/utils/ncaLayer";
import { requestAssistantAutoOpen } from "@/utils/assistantAutoOpen";
import FileDataService from "@/services/filemanager/files/FileDataService";
import {
  getRememberedAccount,
  identityKey,
  listRememberedAccountViews,
  rememberAccount,
  RememberedAccount,
  RememberedAccountView,
  removeRememberedAccount,
} from "@/services/auth/RememberedAccountService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loader = computed(() => {
  return store.getters[LoaderGetters.GET_LOADER];
});

const store = useStore();

const loginType = ref<"ECP" | "Credentials">("Credentials");
const passwordVisible = ref(false);
const rememberedAccounts = ref<RememberedAccountView[]>([]);
const selectedAccount = ref<RememberedAccountView | null>(null);
const manualLogin = ref(false);
const accountsLoaded = ref(false);
const pendingIdentity = ref<AuthIdentity | null>(null);
const remembering = ref(false);
const showAccountChooser = computed(
  () =>
    accountsLoaded.value &&
    rememberedAccounts.value.length > 0 &&
    !selectedAccount.value &&
    !manualLogin.value
);

const selectLoginType = (type: "ECP" | "Credentials") => {
  loginType.value = type;
  passwordVisible.value = false;
};

const errorMessage = ref("");

const state = reactive({
  login: "",
  password: "",
});
const rules = {
  login: { required },
  password: { required },
};
const submitted = ref(false);
const v$ = useVuelidate(rules, state);

const selectAccount = (account: RememberedAccountView) => {
  selectedAccount.value = account;
  manualLogin.value = false;
  state.login = account.login;
  state.password = "";
  errorMessage.value = "";
  ecpErrorMessage.value = null;
};

const useAnotherAccount = () => {
  selectedAccount.value = null;
  manualLogin.value = true;
  state.login = "";
  state.password = "";
  submitted.value = false;
  errorMessage.value = "";
};

const backToAccounts = () => {
  selectedAccount.value = null;
  manualLogin.value = false;
  state.login = "";
  state.password = "";
  submitted.value = false;
  errorMessage.value = "";
  ecpErrorMessage.value = null;
};

const removeAccount = async (account: RememberedAccountView) => {
  await removeRememberedAccount(account.key);
  rememberedAccounts.value = await listRememberedAccountViews();
};

const loginUser = async (isFormValid: boolean) => {
  submitted.value = true;
  if (!isFormValid) return;

  await store
    .dispatch(AuthActions.LOGIN, {
      login: state.login,
      password: state.password,
    })
    .then(async (identity: AuthIdentity) => {
      await handleSuccessfulLogin(identity);
    })
    .catch((error) => {
      errorMessage.value = error.response?.data?.message || t("auth.accountUnavailable");
    });
};
const ecpErrorMessage = ref<string | null>(null);

// Login by ecp
const loginUserByECP = async () => {
  ecpErrorMessage.value = null;

  const base64 = "QXV0aG9yaXphdGlvbg==";
  try {
    const signature = await createAuthCmsSignatureFromBase64(base64);
    const identity = (await store.dispatch(AuthActions.LOGIN_BY_ECP, {
      sign: signature,
      login: state.login,
    })) as AuthIdentity;
    await handleSuccessfulLogin(identity);
  } catch (error: any) {
    const responseData = error?.data ?? error?.response?.data;
    if (responseData && !responseData.status) {
      ecpErrorMessage.value = responseData.message;
      return;
    }
    if (confirm(t("auth.ncaError"))) {
      location.reload();
    }
  }
};

const handleSuccessfulLogin = async (identity: AuthIdentity) => {
  if (
    selectedAccount.value &&
    identityKey(identity) !== selectedAccount.value.key
  ) {
    await store.dispatch(AuthActions.LOGOUT);
    errorMessage.value = t("auth.accountMismatch");
    state.password = "";
    return;
  }

  const existing = await getRememberedAccount(identityKey(identity));
  if (existing) {
    await updateRememberedAccount(identity, existing);
    finishLogin();
    return;
  }
  pendingIdentity.value = identity;
};

const confirmRememberAccount = async () => {
  if (!pendingIdentity.value) {
    return;
  }
  remembering.value = true;
  try {
    await updateRememberedAccount(pendingIdentity.value);
    finishLogin();
  } finally {
    remembering.value = false;
  }
};

const skipRememberAccount = () => finishLogin();

const updateRememberedAccount = async (
  identity: AuthIdentity,
  existing?: RememberedAccount
) => {
  let logoDataUrl: string | null | undefined;
  const logoGuid = identity.tenant?.logoFileGuid || null;
  if (!logoGuid) {
    logoDataUrl = null;
  } else if (logoGuid !== existing?.logoFileGuid) {
    logoDataUrl = await downloadLogo(logoGuid);
  }
  await rememberAccount(identity, logoDataUrl);
};

const downloadLogo = async (logoGuid: string): Promise<string | null> => {
  try {
    const response = await FileDataService.download(logoGuid);
    const fileData = String(response.data?.fileData || "");
    const contentType = response.data?.fileInfo?.type;
    const allowedTypes = new Set(["image/png", "image/jpeg", "image/webp"]);
    if (!fileData || !allowedTypes.has(contentType)) {
      return null;
    }
    return `data:${contentType};base64,${fileData}`;
  } catch {
    return null;
  }
};

const finishLogin = () => {
  requestAssistantAutoOpen();
  const redirect = router.currentRoute.value.query.redirect as
    | string
    | undefined;
  window.location.replace(
    redirect &&
      redirect.startsWith("/") &&
      !redirect.startsWith("//") &&
      !redirect.includes("\\")
      ? redirect
      : "/dashboard"
  );
};

const accountDisplayName = (account: RememberedAccount) =>
  account.tenantName || t("auth.platformAdministrator");

const accountInitials = (account: RememberedAccount) =>
  initials(account.tenantName || account.login);

const identityInitials = (identity: AuthIdentity) =>
  initials(identity.tenant?.name || identity.login || identity.username || "");

const initials = (value: string) =>
  value
    .split(/\s+/)
    .map((part) => part.replace(/[^A-Za-zА-Яа-яЁёӘәҒғҚқҢңӨөҰұҮүҺһІі0-9]/g, ""))
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

onMounted(async () => {
  await store.dispatch(LoaderActions.SET_LOADER, false);
  rememberedAccounts.value = await listRememberedAccountViews();
  accountsLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(loader))
          ? (_openBlock(), _createBlock(Loader, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (pendingIdentity.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(identityInitials(pendingIdentity.value)), 1)
              ]),
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("auth.rememberAccountTitle")), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("auth.rememberAccountDescription")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(Button), {
                  disabled: remembering.value,
                  onClick: confirmRememberAccount
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("auth.rememberAccount")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(Button), {
                  variant: "default",
                  disabled: remembering.value,
                  onClick: skipRememberAccount
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("auth.notNow")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : (_unref(showAccountChooser))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t("auth.chooseAccount")), 1),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rememberedAccounts.value, (account) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: account.key,
                      class: "account-card"
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "account-card__select",
                        onClick: ($event: any) => (selectAccount(account))
                      }, [
                        _createElementVNode("span", _hoisted_12, [
                          (account.logoDataUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: account.logoDataUrl,
                                alt: ""
                              }, null, 8, _hoisted_13))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(accountInitials(account)), 1))
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(accountDisplayName(account)), 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(account.login), 1)
                        ])
                      ], 8, _hoisted_11),
                      _createElementVNode("button", {
                        type: "button",
                        class: "account-card__remove",
                        title: _ctx.$t('auth.removeAccount'),
                        "aria-label": _ctx.$t('auth.removeAccount'),
                        onClick: ($event: any) => (removeAccount(account))
                      }, " × ", 8, _hoisted_18)
                    ]))
                  }), 128))
                ]),
                _createVNode(_unref(Button), {
                  class: "mt-6 w-full",
                  variant: "default",
                  onClick: useAnotherAccount
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("auth.useAnotherAccount")), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (selectedAccount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        (selectedAccount.value.logoDataUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: selectedAccount.value.logoDataUrl,
                              alt: ""
                            }, null, 8, _hoisted_21))
                          : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(accountInitials(selectedAccount.value)), 1))
                      ]),
                      _createElementVNode("span", _hoisted_23, [
                        _createElementVNode("strong", _hoisted_24, _toDisplayString(accountDisplayName(selectedAccount.value)), 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(selectedAccount.value.login), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-sm text-primary-500",
                        onClick: backToAccounts
                      }, _toDisplayString(_ctx.$t("auth.changeAccount")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (loginType.value === 'ECP')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("auth.ecpAccountLogin")), 1),
                      (!selectedAccount.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            id: "ecp-account-login",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).login) = $event)),
                            type: "text",
                            autocomplete: "username",
                            maxlength: "100",
                            class: "input-form w-full my-2",
                            placeholder: _ctx.$t('auth.loginPlaceholder')
                          }, null, 8, _hoisted_27)), [
                            [
                              _vModelText,
                              _unref(state).login,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("auth.welcomeFull")), 1),
                      _createVNode(_unref(Button), {
                        onClick: loginUserByECP,
                        class: "mx-auto block my-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("auth.loginWithEcp")), 1)
                        ]),
                        _: 1
                      }),
                      (ecpErrorMessage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(ecpErrorMessage.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("auth.or")), 1),
                      _createElementVNode("p", _hoisted_31, [
                        _createTextVNode(_toDisplayString(_ctx.$t("auth.loginWith")) + " ", 1),
                        _hoisted_32,
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (selectLoginType('Credentials')), ["prevent"])),
                          class: "text-primary-300 font-bold"
                        }, _toDisplayString(_ctx.$t("auth.loginAndPassword")), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (loginType.value === 'Credentials')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 2,
                      class: "text-center pl-4 pr-4",
                      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (loginUser(!_unref(v$).$invalid)), ["prevent"]))
                    }, [
                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("auth.welcomeShort")), 1),
                      (!selectedAccount.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            placeholder: _ctx.$t('auth.loginPlaceholder'),
                            class: _normalizeClass(["input-form w-full mt-10", {
              'p-invalid': _unref(v$).login.$invalid && submitted.value,
            }]),
                            autocomplete: "username",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).login.$model) = $event))
                          }, null, 10, _hoisted_34)), [
                            [
                              _vModelText,
                              _unref(v$).login.$model,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: passwordVisible.value ? 'text' : 'password',
                          placeholder: _ctx.$t('auth.passwordPlaceholder'),
                          class: _normalizeClass(["input-form w-full pr-12", {
                'p-invalid': _unref(v$).password.$invalid && submitted.value,
              }]),
                          autocomplete: "current-password",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).password.$model) = $event))
                        }, null, 10, _hoisted_36), [
                          [_vModelDynamic, _unref(v$).password.$model]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "password-visibility-toggle absolute inset-y-0 right-0 flex w-12 items-center justify-center rounded-r-lg text-gray-500 transition-colors hover:text-gray-700",
                          "aria-label": 
                _ctx.$t(passwordVisible.value ? 'auth.hidePassword' : 'auth.showPassword')
              ,
                          title: 
                _ctx.$t(passwordVisible.value ? 'auth.hidePassword' : 'auth.showPassword')
              ,
                          "aria-pressed": passwordVisible.value,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (passwordVisible.value = !passwordVisible.value))
                        }, [
                          (passwordVisible.value)
                            ? (_openBlock(), _createBlock(_unref(EyeOffIcon), {
                                key: 0,
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              }))
                            : (_openBlock(), _createBlock(_unref(EyeIcon), {
                                key: 1,
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              }))
                        ], 8, _hoisted_37)
                      ]),
                      _createVNode(_unref(Button), {
                        class: "w-full mt-6",
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("auth.loginButton")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("p", _hoisted_38, _toDisplayString(errorMessage.value), 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("p", _hoisted_40, [
                          _createTextVNode(_toDisplayString(_ctx.$t("auth.loginWith")) + " ", 1),
                          _hoisted_41,
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (selectLoginType('ECP')), ["prevent"])),
                            class: "text-primary-300 font-bold"
                          }, _toDisplayString(_ctx.$t("auth.ecp")), 1)
                        ])
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ])
  ], 64))
}
}

})